<template>
    <v-app-bar color="#212121" app flat height="60" :elevation="0" style="width: 100%;">
        <div class="d-flex align-center" style="width: 100%; height: 60px;">
            <!-- Logo and Brand -->
            <div class="d-flex align-center justify-space-between px-0 py-2" style="height: 57px !important;">
                <router-link :to="$root.currentUser && $root.currentUser.userId ? '/app' : '/app/apuntes-preguntas-flashcards/2027'" class="d-flex align-center text-decoration-none brand-link">
                    <v-card color="#264C00" class="pa-1"
                        style="border-radius: 16px !important; z-index: 2; position: relative; box-shadow: 0 3px 0 0 rgb(72 105 39) !important; margin-top: -3px !important;"
                        flat>
                        <v-img src="../../../assets/logo.png" width="38" height="38" max-width="38" contain
                            class="logo-image"></v-img>
                    </v-card>
                    <logo class="ml-3" :dark="true" />
                </router-link>
            </div>

            <!-- Separator -->
            <div
            v-if="!$vuetify.breakpoint.xs"
            class="mx-4 my-auto" style="height: 25px !important; width: 1px; background-color: rgb(85 85 85)">
            </div>






            <!-- Document Name -->
            <span v-if="subjectName && !$vuetify.breakpoint.smAndDown" 
            @click="$router.push('/app?subject=' + subjectId)"
            class="white--text font-weight-medium font-rubik d-inline-block mr-1" 
                  style="max-height: 50px; line-height: 24px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; text-decoration: underline; cursor: pointer">
                {{ subjectName }}
            </span>

            <span v-if="subjectName && !$vuetify.breakpoint.smAndDown" 
            class="white--text font-weight-medium font-rubik d-inline-block mr-1" >></span>

            <!-- Document Name -->
            <span v-if="documentName && !$vuetify.breakpoint.xs" 
            class="white--text font-weight-medium font-rubik d-inline-block" 
                  style="flex: 1; max-height: 50px; line-height: 24px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                {{ documentName }}
            </span>



            <!-- View PDF Button -->
            <v-btn 
            v-if="false"
            @click="requestPdfView"
            text
            color="rgb(171 171 171)"
            :width="$vuetify.breakpoint.smAndDown ? '40px' : '100px'"
            style="cursor: pointer; user-select: none;"
                class="d-flex align-center ml-4 rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="rgb(35 228 82)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-file-icon lucide-file">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                </svg>

                <span
                v-if="!$vuetify.breakpoint.smAndDown"
                style="color: rgb(35 228 82)" class="font-rubik font-weight-bold ml-2">Ver documento</span>
            </v-btn>



            <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>

            <!-- Progress Indicator -->
            <div class="d-flex align-center">
                <!-- Pomodoro Timer -->
                <pomodoro-timer
                v-if="!$vuetify.breakpoint.xs && false"
                :work-duration="45" :break-duration="5"></pomodoro-timer>


                <v-tooltip bottom color="black" nudge-bottom="2">
                    <template v-slot:activator="{ on, attrs }">
                        <v-progress-circular :rotate="-90" :size="40" :width="4" :value="progress"
                            color="light-green accent-3" v-bind="attrs" v-on="on">
                            <v-icon color="amber lighten-1" small>mdi-trophy-variant</v-icon>
                        </v-progress-circular>
                    </template>
                    <span class="font-rubik font-weight-bold">{{ completedCount }} de {{ totalCount }}
                        completados.</span>
                </v-tooltip>

                  <!-- Share Button -->
                  <v-tooltip bottom color="black" nudge-bottom="2">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="mx-4 button-share"
                        :style="($root.currentUser && $root.currentUser.premium) ? 'margin-right: 50px !important;' : ($vuetify.breakpoint.xs ? 'margin-right: 50px !important; min-width: 44px !important; width: 44px !important;' : '')"
                        @click="openShareDialog">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        :class="$vuetify.breakpoint.xs ? 'mr-0' : 'mr-2'"
                        class="lucide lucide-share-icon lucide-share"><path d="M12 2v13"/><path d="m16 6-4-4-4 4"/><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/></svg>
                        <span v-if="!$vuetify.breakpoint.xs">
                            Compartir
                        </span>
                        </v-btn>
                    </template>
                    <span class="font-rubik font-weight-bold">Compartir</span>
                </v-tooltip>

      
                <!-- Subscribe Button -->
                <v-btn 
                v-if="!$root.currentUser.premium && !$vuetify.breakpoint.xs"
                style="margin-right: 60px"
                class="subscribe-btn font-rubik" height="44" depressed @click="openFeaturesDialog('appbar_premium_cta')">
                    <!-- Desbloquea el Premium -->
                     Aprovecha sin límites

                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="ml-2 lucide lucide-trending-up-icon lucide-trending-up">
                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                        <polyline points="16 7 22 7 22 13" />
                    </svg>

                </v-btn>

                <!-- User Button -->
                <!-- <user-button v-if="$root.currentUser" class="ml-3"></user-button> -->

              
            </div>
        </div>

        <!-- Share Dialog -->
        <share-document-dialog v-if="documentId && documentName" v-model="showShareDialog" :document-id="documentId"
            :document-name="documentName" />

        <features-dialog :showDialog.sync="showFeaturesDialog" />
    </v-app-bar>
</template>

<script>
import UserButton from '../../profile/login/UserButton.vue'
import Logo from './Logo.vue'
import ShareDocumentDialog from './ShareDocumentDialog.vue'; // Import Share Dialog
import { eventBus } from '../../../eventBus'; // Importar Event Bus
import FeaturesDialog from '../../../components/premium/FeaturesDialog.vue';
import PomodoroTimer from './PomodoroTimer.vue'; // Importar el componente PomodoroTimer

export default {
    name: 'DocumentAppBar',
    components: {
        UserButton,
        Logo,
        ShareDocumentDialog,
        FeaturesDialog,
        PomodoroTimer // Registrar el componente
    },
    props: {
        documentId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            subjectName: "",
            subjectId: null,
            documentName: null,
            progress: 0,
            totalCount: 0,
            completedCount: 0,
            isLoading: false,
            showShareDialog: false,
            showFeaturesDialog: false, // Add state for share dialog
        };
    },
    watch: {
        documentId: {
            immediate: true,
            handler(newId) {
                if (newId) {
                    this.fetchData();
                } else {
                    this.documentName = null;
                    this.progress = 0;
                }
            }
        },
        showFeaturesDialog(isShown) {
            if (!isShown && this.$route.query.premium_from) {
                const query = { ...this.$route.query };
                delete query.premium_from;
                this.$router.push({ query }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err);
                    }
                });
            }
        },
    },
    mounted() {
        // Escuchar el evento del Event Bus
        eventBus.$on('documentProgressUpdated', this.handleProgressUpdate);
    },
    beforeDestroy() {
        // Dejar de escuchar el evento para evitar memory leaks
        eventBus.$off('documentProgressUpdated', this.handleProgressUpdate);
    },
    methods: {
        openShareDialog() {
            if (this.documentId && this.documentName) {
                this.showShareDialog = true;
            } else {
                console.warn("Cannot open share dialog: documentId or documentName is missing.");
                // Optionally show a toast or message
            }
        },
        requestPdfView() {
            console.log('APPBAR: Emitting requestPdfView event via EventBus for document:', this.documentId); // DEBUG
            eventBus.$emit('requestPdfView', { documentId: this.documentId });
        },
        handleProgressUpdate(data) {
            // Este método ahora maneja la lógica que estaba en el watcher
            console.log('APPBAR: Received documentProgressUpdated event via EventBus. Data:', data); // DEBUG
            console.log('APPBAR: Comparing IDs. Event ID:', data?.documentId, 'Component ID:', this.documentId); // DEBUG
            if (data && data.documentId === this.documentId) {
                console.log('APPBAR: IDs match. Calling calculateProgressFromBlocks.'); // DEBUG
                this.calculateProgressFromBlocks(data.blocks);
            } else {
                console.log('APPBAR: IDs do NOT match or data missing.'); // DEBUG
            }
        },
        async fetchData() {
            if (!this.documentId) return;
            this.isLoading = true;
            await Promise.all([
                this.fetchDocumentDetails(),
                this.fetchProgress()
            ]);
            this.isLoading = false;
        },
        async fetchDocumentDetails() {
            try {
                const response = await this.axios.get(`/documents/${this.documentId}`, {
                    headers: { Authorization: this.$root.token.value }
                });
                if (response.data.success) {
                    this.documentName = response.data.document.name;
                    this.subjectName = response.data.document.subject_name;
                    this.subjectId = response.data.document.subject_id;                    ;
                } else {
                    console.error('Error fetching document details:', response.data.error);
                    this.documentName = 'Documento';
                }
            } catch (error) {
                console.error('Error fetching document details:', error);
                this.documentName = 'Documento';
            }
        },
        async fetchProgress() {
            try {


                if (!this.$root.currentUser || !this.$root.currentUser.userId) {
                    this.progress = 0;
                    return;
                }

                // Obtener la estructura para saber el total de items
                const structureResponse = await this.axios.post(`/documents/${this.documentId}/structure`, {
                    userId: this.$root.currentUser.userId,
                });

                if (!structureResponse.data.success || !structureResponse.data.structure) {
                    console.error('Failed to fetch structure for progress calculation');
                    this.progress = 0;
                    return;
                }
                const structure = structureResponse.data.structure;
                

                // Obtener el estado de completado
                const completionResponse = await this.axios.get(`/documents/${this.documentId}/user-progress`, {
                    headers: { Authorization: this.$root.token.value }
                });

                if (!completionResponse.data.success) {
                    console.error('Failed to fetch completion data');
                    this.progress = 0;
                    return;
                }
                const completionData = completionResponse.data.progress || {};

                this.calculateProgress(structure, completionData);

            } catch (error) {
                console.error('Error fetching progress data:', error);
                this.progress = 0;
            }
        },
        calculateProgress(structure, completionData) {
            let completedCount = 0;
            let totalCount = 0;
            const contentTypes = ['summary', 'flashcards', 'quiz']; // Tipos de contenido que cuentan para el progreso

            structure.forEach(block => {
                const blockCompletion = completionData[block.id] || {};
                contentTypes.forEach(type => {
                    totalCount++;
                    if (blockCompletion[type]) {
                        completedCount++;
                    }
                });
            });

            this.progress = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;
            console.log(`Initial Progress calculated: ${completedCount}/${totalCount} = ${this.progress}%`);

            this.totalCount = totalCount;
            this.completedCount = completedCount;
        },
        calculateProgressFromBlocks(blocks) {
            console.log('APPBAR: calculateProgressFromBlocks received blocks:', JSON.parse(JSON.stringify(blocks))); // DEBUG
            let completedCount = 0;
            let totalCount = 0;

            blocks.forEach(block => {
                // Ignorar el bloque de PDF global si existe
                if (block.isPdfViewerEntry) return;

                if (block.subItems && Array.isArray(block.subItems)) {
                    block.subItems.forEach(item => {
                        // Asegurarse de que solo contamos los tipos relevantes si es necesario,
                        // o simplemente todos los subItems si la estructura es consistente.
                        // Asumimos que todos los subItems cuentan para el progreso aquí.
                        totalCount++;
                        if (item.completed) {
                            completedCount++;
                        }
                    });
                }
            });

            this.progress = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;
            console.log(`APPBAR: Progress updated from event: ${completedCount}/${totalCount} = ${this.progress}%`);
        },
        openFeaturesDialog(origin) {
            this.$router.push({ query: { ...this.$route.query, premium_from: origin } }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                }
            });
            this.showFeaturesDialog = true;
        },
    }
}
</script>

<style scoped>
/* Copied relevant styles from MainBar.vue - adjust as needed */
.brand-link {
    position: relative;
    transition: transform 0.3s ease;
}

.logo-image {
    transition: all 0.3s ease;
}

.subscribe-btn {
    position: relative;
    border-radius: 12px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em !important;
    /* box-shadow: 0 6px 0 #58a700 !important; */
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden;
    height: 39px !important;
    transform: translateY(0) !important;
    background: #4DD453 !important;
    box-shadow: 0 3px 0 #42B848 !important;
    color: white !important;
    margin-top: -2px !important;

}

.button-share {
    background-color: white !important;
    box-shadow: 0 3px 0 #bebebe !important;
    color: #525866 !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden;
    height: 39px !important;
    transform: translateY(0) !important;
    border-radius: 12px !important;
    margin-top: -2px !important;
}

/* Add specific styles for DocumentAppBar if necessary */
</style>